import { app } from '../firebase/firebaseConfig';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

let analyticsInstance = null;
let analyticsInitPromise = null;
let pixelInitialized = false;

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

async function initAnalytics() {
    if (analyticsInstance) {
        return analyticsInstance;
    }
    if (!analyticsInitPromise) {
        if (typeof window === 'undefined') {
            analyticsInitPromise = Promise.resolve(null);
        } else {
            analyticsInitPromise = isSupported()
                .then((supported) => {
                    if (!supported) {
                        return null;
                    }
                    analyticsInstance = getAnalytics(app);
                    return analyticsInstance;
                })
                .catch(() => null);
        }
    }
    return analyticsInitPromise;
}

function initMetaPixel() {
    if (pixelInitialized || typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    if (!META_PIXEL_ID) {
        return;
    }
    const existing = window.fbq;
    if (typeof existing === 'function') {
        existing('init', META_PIXEL_ID);
        existing('track', 'PageView');
        pixelInitialized = true;
        return;
    }

    const fbq = function fbqFunc() {
        fbqFunc.callMethod ? fbqFunc.callMethod.apply(fbqFunc, arguments) : fbqFunc.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
        window.fbq('init', META_PIXEL_ID);
        window.fbq('track', 'PageView');
    };
    document.head.appendChild(script);
    pixelInitialized = true;
}

export async function initializeTracking() {
    await initAnalytics();
    initMetaPixel();
}

export async function trackEvent(eventName, params = {}) {
    try {
        const analytics = await initAnalytics();
        if (analytics) {
            logEvent(analytics, eventName, params);
        }
    } catch (err) {
        console.warn('Analytics event failed', eventName, err);
    }

    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, params);
    }
}

export async function trackScreenView(screenName) {
    const analytics = await initAnalytics();
    if (!analytics) {
        return;
    }
    try {
        logEvent(analytics, 'screen_view', {
            firebase_screen: screenName,
            firebase_screen_class: screenName,
        });
    } catch (err) {
        console.warn('Failed to track screen view', screenName, err);
    }
}

export async function trackUserFunnel(step, details = {}) {
    await trackEvent(`funnel_${step}`, details);
}
